import styled from "styled-components";

export default styled.div`
    margin-bottom: 20px;

    .companySelect {
        height: 40px;
        width: 300px;
        position: absolute;
        right: 0;
        top: 0;

        @media (max-width: 1024px) {
            position: relative;
        }
    }

    .noData {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 200px;

        svg {
            font-size: 50px;
            color: ${(props) => props.theme.tableHeadCellBackground};
            margin-bottom: 20px;
        }

        .spinner {
            animation: spin 2s linear infinite;
        }

        p {
            color: ${(props) => props.theme.tableHeadCellBackground};
            letter-spacing: 0.1em;
            text-align: center;
        }

        .highlight {
            font-weight: 600;
        }
    }

    .voteScore {
        display: flex;
        justify-content: center;
        align-items: center;

        border-radius: 5px;

        max-width: 25px;
        min-width: 25px;
        max-height: 25px;
        min-height: 25px;

        color: black;
        font-weight: bolder;

        &.score-1 {
            background-color: ${(props) => props.theme.bqmqVoteScore1};
        }
        &.score-2 {
            background-color: ${(props) => props.theme.bqmqVoteScore2};
        }
        &.score-3 {
            background-color: ${(props) => props.theme.bqmqVoteScore3};
        }
        &.score-4 {
            background-color: ${(props) => props.theme.bqmqVoteScore4};
        }
        &.score-5 {
            background-color: ${(props) => props.theme.bqmqVoteScore5};
        }
    }
`;
